import { createAsyncThunk } from '@reduxjs/toolkit'
import { getDocuments, getDocumentById, deleteDocumentsServer, getManyDocumentsByIds, getBlankDocument } from '../services/documentsServices'

export const documentsList = createAsyncThunk(
	'documents/fetchDocuments',
	async (_, { rejectWithValue, getState }) => {
		try {
			const token = localStorage.getItem('access_token')
			const data = await getDocuments(token)
			return data
		} catch (error) {
			if (error.response?.status === 401) {
				return rejectWithValue('Unauthorized: Пожалуйста, войдите снова')
			}
			return rejectWithValue(
				error.response?.data || 'Ошибка загрузки документов'
			)
		}
	}
)

export const fetchDocumentById = createAsyncThunk(
	'documents/fetchDocumentById',
	async (documentId, { rejectWithValue }) => {
		try {
			const token = localStorage.getItem('access_token')
			const data = await getDocumentById(documentId, token)
			return data
		} catch (error) {
			if (error.response?.status === 401) {
				return rejectWithValue('Unauthorized: Пожалуйста, войдите снова')
			}
			return rejectWithValue(
				error.response?.data || 'Ошибка загрузки документа'
			)
		}
	}
)


export const deleteDocuments = createAsyncThunk(
    'documents/deleteDocuments',
    async (documentIds, { rejectWithValue }) => {
        try {
            const token = localStorage.getItem('access_token')
            
            const data = await deleteDocumentsServer(documentIds, token)
            return data
        } catch (error) {
            if (error.response?.status === 401) {
                return rejectWithValue('Unauthorized: Пожалуйста, войдите снова')
            }
            return rejectWithValue(
                error.response?.data || 'Ошибка удаления документов'
            )
        }
    }
)


export const fetchBlankDocument = createAsyncThunk(
    'documents/fetchBlankDocument',
    async (_, { rejectWithValue }) => {
        try {
            const token = localStorage.getItem('access_token')
            const data = await getBlankDocument(token)
            return data
        } catch (error) {
            if (error.response?.status === 401) {
                return rejectWithValue('Unauthorized: Пожалуйста, войдите снова')
            }
            return rejectWithValue(
                error.response?.data || 'Ошибка загрузки документа чистого листа'
            )
        }
    }
)


export const fetchDocumentsByIds = createAsyncThunk(
    'documents/fetchDocumentsByIds',
    async (documentIds, { rejectWithValue }) => {
        try {
            const token = localStorage.getItem('access_token');
            const data = await getManyDocumentsByIds(documentIds, token);
            return data;
        } catch (error) {
            if (error.response?.status === 401) {
                return rejectWithValue('Unauthorized: Пожалуйста, войдите снова');
            }
            return rejectWithValue(error.response?.data || 'Ошибка загрузки документов');
        }
    }
);
